var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dialog-list-item',{attrs:{"icon":"columns","subtitle":_vm.selected.length
      ? _vm.$t('search_and_filter.n_items_selected', {
          count: _vm.selected.length,
          name: _vm.$t('common.list', { count: _vm.selected.length })
        })
      : null,"title":_vm.$t('common.list', { count: 0 }),"toolbar-title":_vm.$t('common.list', { count: 0 })}},[_c('base-expansion-list',{attrs:{"multiple":true,"items":_vm.boardsWithLists,"selected":_vm.selected,"empty-list-text":_vm.$t('search_and_filter.results.not_found.lists')},on:{"update:selected":function($event){_vm.selected=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }